// Minimal syntax colouring for the API docs' code samples (JSON, curl, Python, JavaScript): JSON keys, strings,
// numbers, keywords, literals and comments. A small scanner instead of a highlighting library keeps the bundle lean.
// Returns [{ text, kind }] pieces that join back into the code; kind is null for plain text.

const STRING_DQ = /"(?:[^"\\\n]|\\.)*"/y;
const NUMBER = /-?\d+(?:\.\d+)?(?![\w.])/y;

// [kind, sticky regex, options]: word = only at a word start; afterSpace = only at a line start or after a space
const RULES = {
  json: [
    ['key', /"(?:[^"\\\n]|\\.)*"(?=\s*:)/y],
    ['string', STRING_DQ],
    ['number', NUMBER, { word: true }],
    ['literal', /(?:true|false|null)(?![\w$])/y, { word: true }],
  ],
  curl: [
    ['comment', /#[^\n]*/y, { afterSpace: true }],
    ['string', /'[^'\n]*'|"(?:[^"\\\n]|\\.)*"/y],
  ],
  python: [
    ['comment', /#[^\n]*/y, { afterSpace: true }],
    ['string', /f?"(?:[^"\\\n]|\\.)*"|f?'(?:[^'\\\n]|\\.)*'/y],
    ['keyword', /(?:import|from|while|for|in|if|else|print|True|False|None)(?![\w$])/y, { word: true }],
    ['number', NUMBER, { word: true }],
  ],
  javascript: [
    ['comment', /\/\/[^\n]*/y],
    ['string', /'(?:[^'\\\n]|\\.)*'|"(?:[^"\\\n]|\\.)*"|`(?:[^`\\]|\\.)*`/y],
    ['keyword', /(?:const|let|await|async|new|while|if|else|return|true|false|null)(?![\w$])/y, { word: true }],
    ['number', NUMBER, { word: true }],
  ],
};

export function highlight(code, lang) {
  const rules = RULES[lang] || [];
  const pieces = [];
  let plain = '';
  let i = 0;
  while (i < code.length) {
    const prev = i > 0 ? code[i - 1] : '';
    let found = null;
    for (const [kind, pattern, options = {}] of rules) {
      if (options.word && /[\w$.]/.test(prev)) continue;
      if (options.afterSpace && prev && !/\s/.test(prev)) continue;
      pattern.lastIndex = i;
      const match = pattern.exec(code);
      if (match && match[0]) {
        found = { kind, text: match[0] };
        break;
      }
    }
    if (found) {
      if (plain) pieces.push({ text: plain, kind: null });
      plain = '';
      pieces.push(found);
      i += found.text.length;
    } else {
      plain += code[i];
      i += 1;
    }
  }
  if (plain) pieces.push({ text: plain, kind: null });
  return pieces;
}
